export default __webpack_public_path__ + "static/diamond-4-7af60fc69d6679a4143605aa54474474.png";